export default __webpack_public_path__ + "static/media/google-plus-original.b39ed503.svg";